import { isInScopeDiffMode } from 'scope/scopeDiff';
import {
  openVisualDiff,
  updateEnhancedScopeDiffData,
  updateScopeDiff,
} from 'scope/actions';
import { dispatchAction } from '@ardoq/rxbeach';
import { PersonalSetting } from '@ardoq/api-types';
import { usePersonalSetting } from 'streams/currentUser/usePersonalSetting';
import {
  CloseVisualDiffClickSource,
  trackClickCloseVisualDiff,
} from 'scope/tracking';
import { trackEvent } from 'tracking/tracking';
import { MainAppModuleTrackingEventsNames } from '../../tracking';
export const useShowFilteredComponents = (): [boolean, () => void] => {
  const [showFilteredComponents, setShowFilteredComponents] =
    usePersonalSetting(PersonalSetting.GENERIC_SHOW_FILTERED_COMPONENTS);
  const areFilteredComponentsShown = showFilteredComponents ?? false;

  const toggleShowFilteredComponentsAndTrack = () => {
    trackEvent(
      areFilteredComponentsShown
        ? MainAppModuleTrackingEventsNames.HIDE_FILTERED_COMPONENTS
        : MainAppModuleTrackingEventsNames.SHOW_FILTERED_COMPONENTS
    );
    setShowFilteredComponents(!areFilteredComponentsShown);
  };

  return [areFilteredComponentsShown, toggleShowFilteredComponentsAndTrack];
};

export const closeVisualDiff = () => {
  dispatchAction(updateScopeDiff({ scopeDiff: null }));
  dispatchAction(
    updateEnhancedScopeDiffData({
      main: null,
      branch: null,
      branchOff: null,
      diffData: null,
    })
  );
};

export const toggleVisualDiff = ({
  clickSource,
}: {
  clickSource: CloseVisualDiffClickSource;
}) => {
  if (isInScopeDiffMode()) {
    closeVisualDiff();
    trackClickCloseVisualDiff(clickSource);
    return;
  }
  dispatchAction(openVisualDiff({ clickSource }));
};
